// Termos e privacidade: no site a página pública aparece pelo _layout (sem entrar na conta).
// Com o app aberto (link no celular), volta para o início; o texto completo fica em Ajustes.
import { Redirect } from 'expo-router';
export { ErrorBoundary } from '../components/Falha';
export default function Legal() { return <Redirect href="/" />; }
